export const ADDRESS_HIDDEN_REGEXP = /address (hidden|not disclosed)/i
